declare const __BUILD_INFO__: { buildId: string; revision: string; dirty: boolean; sourceId: string };
export const CLIENT_BUILD = typeof __BUILD_INFO__ === 'undefined'
  ? { buildId: 'test', revision: 'unavailable', dirty: true, sourceId: 'unavailable' }
  : __BUILD_INFO__;
